import urlHelper from '../helpers/url'
import { model } from '../core/model'
import { Config } from '../core/config'
import Logout from '../controllers/logout'
import Analytics from '../helpers/analytics'
import YaTiene from '../controllers/yaTiene'

const bind = () => {
    window.removeEventListener("storage", localStorageListener);
    window.addEventListener("storage", localStorageListener);

    document.querySelectorAll('.next-button').forEach((btn) => {
        btn.removeEventListener('click', clickListener);
        btn.addEventListener('click', clickListener)
    })
    document.querySelectorAll('.event-track').forEach((btn) => {
        btn.removeEventListener('click', clickListenerforHREFS);
        btn.addEventListener('click', clickListenerforHREFS)
    })
}

const localStorageListener = (event) => {
    if (event.key !== 'userLogedIn') return; // ignore other keys
    var message = JSON.parse(event.newValue);
    if (!message) return; // ignore empty msg or msg reset

    if (message === true) {
        model.Usuario.initModel()
        if (model.Usuario.hasAccesoDigital()) {
            YaTiene();
        }
    }
}

const clickListener = (event) => {
    switch (event.target.dataset.step) {
        case 'combo_procesar':
            Analytics.clickCombo(event.target.dataset.name, event.target.dataset.price, model.Window.source);
            redirectToCombo(event.target.dataset.combo)
            break;
        case 'combo_procesar_bonificado':
            Analytics.clickCombo3(model.Window.source);
            redirectToCombo(event.target.dataset.combo)
            break;
        case 'redirect':
            urlHelper.redirect(event.target.dataset.url);
            break;
        case 'ya_tenes_suscripcion':
            Analytics.clickYaTengoSuscripcion();
            urlHelper.redirectToLoginWAction(Config.ACCION_YA_TIENE_SUSCRIPCION);
            break;
        case 'logout':
            Logout().then(()=> {
                    console.log("logout finished")
                    urlHelper.redirectToLoginWAction(Config.ACCION_YA_TIENE_SUSCRIPCION);
                });
            break;
        default:
            window.mostrar_error( { 
                error: `action.clickListener | event.target.dataset.step no atrapado. ${event.target.dataset.step}` 
            })   
    }
}

const clickListenerforHREFS = (event) => {
    event.preventDefault();
    const href = event.currentTarget.href;
    const label = event.currentTarget.dataset.label;
    Analytics.otrosEnlaces(label);
    location.href = href;
}


const redirectToCombo = (combo) => {
    //esta validacion se hace solo por que debo saber si esta logueado para poder avisarle a mobile
    if (model.Usuario.isLoggued()) {
        urlHelper.redirectToCombo(combo)
    }
    else {
        urlHelper.redirectToLoginWCombo(combo)
    }
}


export default {
    bind,
};




// WEBPACK FOOTER //
// ./Statics/scripts/paywall/handlers/action.js